import { useMemo } from "react";
import { Box, TextField } from "@mui/material";
import {
  formatISO,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
} from "date-fns";

// Stores time as ISO string using today’s date as the base
const SurveyEntry_Time = ({ value, onChange, isDisabled }) => {
  const initial = useMemo(() => {
    if (!value) return "";
    try {
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";
      return `${String(d.getHours()).padStart(2, "0")}:${String(
        d.getMinutes()
      ).padStart(2, "0")}`;
    } catch {
      return "";
    }
  }, [value]);

  const handleChange = (evt) => {
    const timeStr = evt.target.value; // format HH:MM
    if (!timeStr) {
      onChange(null);
      return;
    }
    const [hh, mm] = timeStr.split(":").map((n) => parseInt(n, 10));
    if (Number.isNaN(hh) || Number.isNaN(mm)) {
      onChange(null);
      return;
    }
    const today = new Date();
    const withTime = setMilliseconds(
      setSeconds(setMinutes(setHours(today, hh), mm), 0),
      0
    );
    onChange(formatISO(withTime));
  };

  return (
    <Box sx={{ mt: 1 }}>
      <TextField
        type="time"
        size="small"
        fullWidth
        value={initial}
        onChange={handleChange}
        disabled={isDisabled}
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
};

export default SurveyEntry_Time;
